<div class="flex flex-col" *ngIf="circuitId">
  <!-- Holiday mode panel -->
  <app-holiday-mode-panel
    class="mode-panel holiday-mode-panel"
    [circuitId]="circuitId"
  ></app-holiday-mode-panel>

  <app-holiday-mode-panel
    class="mode-panel holiday-mode-panel"
    [circuitId]="circuitId"
    [isHolidayAtHome]="true"
  ></app-holiday-mode-panel>

  <!-- Eco mode panel -->
  <app-eco-mode-panel
    class="mode-panel eco-mode-panel"
    [circuitId]="circuitId"
  ></app-eco-mode-panel>

  <!-- Comfort mode panel -->
  <app-comfort-mode-panel
    class="mode-panel comfort-mode-panel"
    [circuitId]="circuitId"
  ></app-comfort-mode-panel>

  <!-- multiple family house (timeschedules are displayed in tabs - heating circuit, dhw and dhw ciruclation) -->
  <ng-container
    *ngIf="
      (isMultiFamily$ | async | ready)?.properties?.active?.value === true;
      else singleFamilyHouse
    "
  >
    <app-multi-family-house-panel [circuitId]="circuitId"></app-multi-family-house-panel>
  </ng-container>

  <!-- single family house -->
  <ng-template #singleFamilyHouse>
    <app-single-family-house-panel [circuitId]="circuitId"></app-single-family-house-panel>
  </ng-template>
</div>
